import { RoutePath } from "./routePath";

/**
 * Path constants for authentication flows.
 * Covers login, password reset, and identity verification routes.
 */
export const RouteTemplates = {
  createNewPassword: "/create-new-password/:token",
  verifyEmail: "/verify-email/:token",
} as const;

export const authPaths = {
  login: "/login",
  forgotPassword: "/forgot-password",
  createNewPassword: RoutePath(RouteTemplates.createNewPassword),
  verifyEmail: RoutePath(RouteTemplates.verifyEmail),
  createPhone: "/create-phone",
};
